import {SellerError} from './SellerError.js'

export class InvalidPhoneSellerError extends SellerError {}
